module.exports = __webpack_public_path__ + "static/WelcomeToElk9-2f9c8ea3ae11e9650cbb772f86294402.png";